/**
 * Skip Links Component
 *
 * Provides keyboard navigation skip links for WCAG 2.1 AA compliance.
 * Allows users to skip to main content, navigation, or footer.
 */

import React from 'react';

interface SkipLink {
  href: string;
  label: string;
}

const defaultSkipLinks: SkipLink[] = [
  { href: '#main-content', label: 'Skip to main content' },
  { href: '#navigation', label: 'Skip to navigation' },
  { href: '#footer', label: 'Skip to footer' },
];

interface SkipLinksProps {
  links?: SkipLink[];
}

export const SkipLinks: React.FC<SkipLinksProps> = ({ links = defaultSkipLinks }) => {
  return (
    <nav
      className="skip-links sr-only focus-within:not-sr-only"
      aria-label="Skip navigation links"
    >
      <ul className="fixed top-0 left-0 z-[9999] bg-white dark:bg-dark-primary border-2 border-primary-600 p-4 space-y-2">
        {links.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              className="
                block px-4 py-2
                bg-primary-600 text-white
                rounded-md
                font-medium
                hover:bg-primary-700
                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500
                transition-colors
              "
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SkipLinks;
